import type { ICampaignLocationAndLanguage } from "app/components/campaigns/campaigns-wizard/CampaignsWizardConsts";
import type {
    ECampaignsLoadingState,
    ICampaignsConsumptionMetrics,
    IKeywordsCampaignData,
    IMyUserConsumptionMetrics,
    IRTCurrentCampaignData,
    RTContextState,
} from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import type { RTContextReducer } from "app/pages/digital-marketing/keywords-campaigns/infra/RTContextReducer";
import type { DatesRange } from "app/pages/digital-marketing/keywords-campaigns/shared/types";

export enum ERTContextReducerTypes {
    InitialCampaignData = "InitialCampaignData",
    UpdateCurrentCampaignConfiguration = "UpdateCurrentCampaignConfiguration",
    UpdateCampaignsConfigurations = "UpdateCampaignsConfigurations",
    UpdateLoadingState = "UpdateLoadingState",
    UpdateCampaignsConfigurationsAndLoadingState = "UpdateCampaignsConfigurationsAndLoadingState",
    UpdateLoadingLanguagesAndLocationsState = "UpdateLoadingLanguagesAndLocationsState",
    UpdateDemoCampaigns = "UpdateDemoCampaigns",
    UpdateDurationObject = "UpdateDurationObject",
    UpdateMyUserConsumptionMetrics = "UpdateMyUserConsumptionMetrics",
    UpdateLocationsAndLanguagesLists = "UpdateLocationsAndLanguagesLists",
    UpdateCampaignsConsumptionMetrics = "UpdateCampaignsConsumptionMetrics",
    UpdateParamsOnNavigation = "UpdateParamsOnNavigation",
}

export type RTContextActions =
    | {
          type: ERTContextReducerTypes.InitialCampaignData;
          payload: RTContextState;
      }
    | {
          type: ERTContextReducerTypes.UpdateCurrentCampaignConfiguration;
          payload: {
              campaignConfiguration: IRTCurrentCampaignData;
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateCampaignsConfigurations;
          payload: {
              campaignsConfigurations: IKeywordsCampaignData[];
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateLoadingState;
          payload: {
              loadingState: ECampaignsLoadingState;
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateCampaignsConfigurationsAndLoadingState;
          payload: {
              campaignsConfigurations: IKeywordsCampaignData[];
              loadingState: ECampaignsLoadingState;
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateLoadingLanguagesAndLocationsState;
          payload: {
              isLoading: boolean;
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateDemoCampaigns;
          payload: {
              demoCampaigns: IKeywordsCampaignData[];
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateDurationObject;
          payload: {
              durationObject: DatesRange;
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateMyUserConsumptionMetrics;
          payload: {
              myUserConsumptionMetrics: IMyUserConsumptionMetrics;
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateLocationsAndLanguagesLists;
          payload: {
              locationsAndLanguagesLists: ICampaignLocationAndLanguage;
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateCampaignsConsumptionMetrics;
          payload: {
              campaignsConsumptionMetrics: ICampaignsConsumptionMetrics;
          };
      }
    | {
          type: ERTContextReducerTypes.UpdateParamsOnNavigation;
          payload: {
              campaignConfiguration: IRTCurrentCampaignData;
          };
      };

export type RTContextStateReducerType = typeof RTContextReducer;
